import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ModalConfirmationComponent} from './components/modal-confirmation/modal-confirmation.component';
import {ModalInfoComponent} from './components/modal-info/modal-info.component';
import {ModalAddTypeAideComponent} from './components/modal-add-type-aide/modal-add-type-aide.component';
import {ModalAddSousTypeAideComponent} from './components/modal-add-sous-type-aide/modal-add-sous-type-aide.component';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {HydraService} from '../core/services/hydra.service';
import {ControlsMessagesComponent} from './components/controls-messages/controls-messages.component';
import {ModalLabelComponent} from './components/modal-label/modal-label.component';
import {FieldTypesService} from './services/tools/field-types.service';
import {FileUploaderComponent} from './components/file-uploader/file-uploader.component';
import {MaterialImportsModule} from '../material-imports/material-imports.module';
import {GeocoderComponent} from './components/geocoder/geocoder.component';
import {GeocoderLabComponent} from './components/geocoder-lab/geocoder-lab.component';
import {ModalAddUserComponent} from './components/modal-add-user/modal-add-user.component';
import {LocalisationsComponent} from './components/localisations/localisations.component';
import {ModalTextareaComponent} from './components/modal-textarea/modal-textarea.component';
import {DirecteurComponent} from './components/laboratoire/directeur/directeur.component';
import {SelectComponent} from './components/select/select.component';
import {MandatsComponent} from './components/mandats/mandats.component';
import {ModalAddMandatComponent} from './components/modal-add-mandat/modal-add-mandat.component';
import {MotclesComponent} from './components/motcles/motcles.component';
import {
    ModalChoixLaboratoireReferenceComponent
} from './components/modal-choix-laboratoire-reference/modal-choix-laboratoire-reference.component';
import {
    ModalNouveauLaboratoireReferenceComponent
} from './components/modal-nouveau-laboratoire-reference/modal-nouveau-laboratoire-reference.component';
import {
    ModalModifierLaboratoireComponent
} from './components/modal-modifier-laboratoire/modal-modifier-laboratoire.component';
import {
    ModalCharteDeontologiqueComponent
} from './components/modal-charte-deontologique/modal-charte-deontologique.component';
import {SafeHtmlPipe} from '../pipes/safeHtml.pipe';
import {
    ModalDeclarationPubliqueComponent
} from './components/modal-declaration-publique/modal-declaration-publique.component';
import {ModalAddUniteComponent} from './components/modal-add-unite/modal-add-unite.component';
import {ModalAddUniversiteComponent} from './components/modal-add-universite/modal-add-universite.component';
import {DisciplinesV2Component} from './components/disciplines-v2/disciplines-v2.component';
import {ModalLabelTranslationComponent} from './components/modal-label-translation/modal-label-translation.component';
import {LogComponent} from './components/log/log.component';
import {
    ModalChangerCommissionComponent
} from './components/modal-changer-commission/modal-changer-commission.component';
import {ModalFinancementComponent} from './components/modal-financement/modal-financement.component';
import {ModalInfoExpertComponent} from './components/modal-info-expert/modal-info-expert.component';
import {
    ModalFinancementRessourceComponent
} from './components/modal-financement-ressource/modal-financement-ressource.component';
import {ModalExpertComponent} from './components/modal-expert/modal-expert.component';
import {ModalAddUtilisateurComponent} from './components/modal-add-utilisateur/modal-add-utilisateur.component';
import {ModalNommerExpertComponent} from './components/modal-nommer-expert/modal-nommer-expert.component';
import {ModalDossierInvalidComponent} from './components/modal-dossier-invalid/modal-dossier-invalid.component';
import {NumberOnlyDirective} from './directives/numericNumberOnly';
import {
    LocalisationCancerComponent
} from './components/localisations/localisation-cancer/localisation-cancer.component';
import {FooterComponent} from './components/footer/footer.component';
import {StickyDirective} from './directives/sticky.directive';
import {RouterModule} from '@angular/router';
import {FilterPipe, FilterPipeProperty} from '../pipes/filter.pipe';
import {LabStructAndPersoComponent} from './components/lab-struct-and-perso/lab-struct-and-perso.component';
import {
    LabStructAndPersoForDossierComponent
} from './components/lab-struct-and-perso-for-dossier/lab-struct-and-perso-for-dossier';
import {ModalCommentaireComponent} from './components/modal-commentaire/modal-commentaire.component';
import {
    ModalNouveauOrganismeGestionnaireComponent
} from './components/modal-nouveau-organisme-gestionnaire/modal-nouveau-organisme-gestionnaire.component';
import {TranslateModule} from '@ngx-translate/core';
import {
    ModalPublicationAddEditComponent
} from './components/modal-publication-add-edit/modal-publication-add-edit.component';
import {DebugDirective} from './directives/debug.directive';
import {ModalResumeDossierComponent} from './components/modal-resume-dossier/modal-resume-dossier.component';
import {provideNgxWebstorage} from 'ngx-webstorage';
import {ModalPrevNotifsComponent} from './components/modal-prev-notifs/modal-prev-notifs.component';
import {ModalInfoDetailsAideComponent} from './modal-info-details-aide/modal-info-details-aide.component';
import {ModalRecevabililteComponent} from './components/modal-recevabilite/modal-recevabililte.component';
import {ModalGrilleExpertiseComponent} from './components/modal-grille-expertise/modal-grille-expertise.component';
import {
    ModalResumeValidExpertiseComponent
} from './components/modal-resume-valid-expertise/modal-resume-valid-expertise.component';
import {DateMonthComponent} from './components/date-month/date-month.component';
import {
    ModalTranslationDescriptionComponent
} from './components/modal-translation-description/modal-translation-description.component';
import {
    ModalTelechargerDossierComponent
} from './components/modal-telecharger-dossier/modal-telecharger-dossier.component';
import {PasswordStrengthBarComponent} from './components/passwordStrengthBar.component';
import {FileDownloaderComponent} from './components/file-downloader/file-downloader.component';
import {ModalRolesUtilisateurComponent} from './components/modal-roles-utilisateur/modal-roles-utilisateur.component';
import {FiltersDossierComponent} from './components/filters-dossier/filters-dossier.component';
import {AutoSizeDirective, AutoSizeMinDirective} from '../directives/auto-size.directive';
import {
    ModalPolitiqueProtectionDonneesComponent
} from './components/modal-politique-protection-donnees/modal-politique-protection-donnees.component';
import {FilterSearchComponent} from './components/filter-search/filter-search.component';
import {ModalMesMandatsComponent} from './components/modal-mes-mandats/modal-mes-mandats.component';
import {ModalHistoriqueComponent} from './components/modal-historique/modal-historique.component';
import {
    ModalTexteAdministrableComponent
} from './components/modal-texte-administrable/modal-texte-administrable.component';
import {ModalContactComponent} from './components/modal-contact/modal-contact.component';
import {LaboratoireValidationService} from './services/laboratoire-validation.service';
import {keysValueCustomPipe} from '../pipes/keys.pipe';
import {NavigationComponent} from './components/navigation/navigation.component';
import {
    ModalDescriptifTypeFraisFinancementComponent
} from './components/modal-descriptif-type-frais-financement/modal-descriptif-type-frais-financement.component';
import {TextPhoneOnlyDirective} from './directives/textPhoneOnly';
import {TranslationService} from './services/translation.service';
import {ModalDesistementAdminComponent} from './components/modal-desistement-admin/modal-desistement-admin.component';
import {
    ModalSelectionReunionsComponent
} from './components/modal-selection-reunions/modal-selection-reunions.component';
import {TasksListComponent} from './components/tasks-list/tasks-list.component';
import {
    ModalDeclinaisonNotificationComponent
} from './components/modal-declinaison-notification/modal-declinaison-notification.component';
import {LogCommentBoxComponent} from './components/log/log-comment-box/log-comment-box.component';
import {TruncatePipe} from '../pipes/truncate.pipe';
import {ToggleFiltersComponent} from './components/toggle-filters/toggle-filters.component';
import {StrictNumberOnlyDirective} from './directives/strictNumberOnly';
import {LogCommentsListComponent} from './components/log/log-comments-list/log-comments-list.component';
import {TaskCounterComponent} from './components/task-counter/task-counter.component';
import {MatRippleModule} from '@angular/material/core';
import {ModalChoixLangueComponent} from './components/modal-choix-langue/modal-choix-langue.component';
import {
    ModalReouvertureDossierComponent
} from './components/modal-reouverture-dossier/modal-reouverture-dossier.component';
import {
    ModalAjustementDossierComponent
} from './components/modal-ajustement-dossier/modal-ajustement-dossier.component';
import {ModalSelectionUserComponent} from './components/modal-selection-user/modal-selection-user.component';
import {ModalAddRegionComponent} from './components/modal-add-region/modal-add-region.component';
import {DateTimeComponent} from './components/date-time/date-time.component';
import {ModalAideFinancementComponent} from './components/modal-aide-financement/modal-aide-financement.component';
import {ModalEditMotClesComponent} from './components/motcles/modal-edit-motcles/modal-edit-motcles.component';
import {IbanPipe} from '../pipes/iban.pipe';
import {NgxCurrency} from '@dintecom/ngx-currency';
import {ModalSelectionListComponent} from './components/modal-selection-list/modal-selection-list.component';
import {TextareaAutoresizeDirective} from './directives/textarea-autoresize.directive';
import {QuillModule} from 'ngx-quill';
import {HomepageComponent} from './components/homepage/homepage.component';
import {ModalAdresseComponent} from './components/modal-adresse/modal-adresse.component';

import {ArcBtnDirective} from './directives/arc-btn.directive';
import {
    DemandeProlongationDetailComponent
} from './components/demande-prolongation-detail/demande-prolongation-detail.component';
import {ModalSaisieDateComponent} from './components/modal-saisie-date/modal-saisie-date.component';
import {DateService} from '../core/services/date.service';
import {DashboardTasksComponent} from './components/dashboard-tasks/dashboard-tasks.component';
import {ModalDashboardTaskComponent} from './components/modal-dashboard-task/modal-dashboard-task.component';
import {ModalTaskCreateComponent} from './components/modal-task-create/modal-task-create.component';
import {RapportsScientifiquesComponent} from './components/rapports-scientifiques/rapports-scientifiques.component';
import {FilterByAPIComponent} from './filter-by-api/filter-by-api.component';
import {FilterPagerComponent} from './filter-pager/filter-pager.component';
import { ModificationBudgetaireDetailComponent } from './components/modification-budgetaire-detail/modification-budgetaire-detail.component';


const declarationAndExportsComponent = [
    StickyDirective,
    DebugDirective,
    ModalConfirmationComponent,
    ModalInfoComponent,
    ModalAddTypeAideComponent,
    ModalAddSousTypeAideComponent,
    BreadcrumbComponent,
    ControlsMessagesComponent,
    ModalLabelComponent,
    FileUploaderComponent,
    GeocoderComponent,
    GeocoderLabComponent,
    ModalAddUserComponent,
    LocalisationsComponent,
    ModalTextareaComponent,
    DirecteurComponent,
    SelectComponent,
    MandatsComponent,
    ModalPolitiqueProtectionDonneesComponent,
    ModalAddMandatComponent,
    MotclesComponent,
    ModalChoixLaboratoireReferenceComponent,
    ModalNouveauLaboratoireReferenceComponent,
    ModalModifierLaboratoireComponent,
    ModalCharteDeontologiqueComponent,
    SafeHtmlPipe,
    FilterPipe,
    FilterPipeProperty,
    ModalDeclarationPubliqueComponent,
    ModalAddUniteComponent,
    ModalAddUniversiteComponent,
    DisciplinesV2Component,
    ModalLabelTranslationComponent,
    LogComponent,
    ModalChangerCommissionComponent,
    ModalFinancementComponent,
    ModalInfoExpertComponent,
    ModalFinancementRessourceComponent,
    ModalExpertComponent,
    ModalAddUtilisateurComponent,
    ModalNommerExpertComponent,
    ModalDossierInvalidComponent,
    NumberOnlyDirective,
    StrictNumberOnlyDirective,
    TextPhoneOnlyDirective,
    LocalisationCancerComponent,
    FooterComponent,
    LabStructAndPersoComponent,
    LabStructAndPersoForDossierComponent,
    ModalCommentaireComponent,
    ModalNouveauOrganismeGestionnaireComponent,
    ModalPublicationAddEditComponent,
    ModalResumeDossierComponent,
    ModalAideFinancementComponent,
    ModalPrevNotifsComponent,
    ModalInfoDetailsAideComponent,
    ModalRecevabililteComponent,
    ModalGrilleExpertiseComponent,
    ModalResumeValidExpertiseComponent,
    DateMonthComponent,
    ModalTranslationDescriptionComponent,
    ModalTelechargerDossierComponent,
    PasswordStrengthBarComponent,
    FileDownloaderComponent,
    ModalRolesUtilisateurComponent,
    FiltersDossierComponent,
    AutoSizeDirective,
    AutoSizeMinDirective,
    FilterSearchComponent,
    ModalMesMandatsComponent,
    ModalHistoriqueComponent,
    ModalTexteAdministrableComponent,
    ModalContactComponent,
    ModalDesistementAdminComponent,
    ModalSelectionReunionsComponent,
    ModalDeclinaisonNotificationComponent,
    NavigationComponent,
    TruncatePipe,
    ToggleFiltersComponent,
    DateTimeComponent,
    ModalEditMotClesComponent,
    ModalSelectionListComponent,
    IbanPipe,
    ModalSelectionListComponent,
    TextareaAutoresizeDirective,
    ModalAdresseComponent,
    ArcBtnDirective,
    ModalSaisieDateComponent,
    ModalDashboardTaskComponent,
    ModalTaskCreateComponent,
    DemandeProlongationDetailComponent,
    RapportsScientifiquesComponent,
    FilterByAPIComponent,
    FilterPagerComponent,
];

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialImportsModule,
        TranslateModule,
        MatRippleModule,
        NgxCurrency,
        QuillModule,
        ...declarationAndExportsComponent,
        keysValueCustomPipe,
        ModalDescriptifTypeFraisFinancementComponent,
        TasksListComponent,
        LogCommentBoxComponent,
        ToggleFiltersComponent,
        LogCommentsListComponent,
        TaskCounterComponent,
        ModalChoixLangueComponent,
        ModalReouvertureDossierComponent,
        ModalAjustementDossierComponent,
        ModalSelectionUserComponent,
        ModalAddRegionComponent,
        HomepageComponent,
        DashboardTasksComponent,
        ModificationBudgetaireDetailComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialImportsModule,
        TranslateModule,
        ...declarationAndExportsComponent,
        keysValueCustomPipe,
        TasksListComponent,
        TasksListComponent,
        TaskCounterComponent,
        DashboardTasksComponent,
        ModificationBudgetaireDetailComponent,
    ],
    providers: [HydraService, FieldTypesService, LaboratoireValidationService, TranslationService, DateService, provideNgxWebstorage()]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: SharedModule,
        };
    }
}
